<script>
import {
  PAYMENT_STATUS_LABELS,
  PAYMENT_STATUS_UNKNOWN_LABEL,
} from "%/constants/subscription-constants";
import {
  SubscriptionPaymentCardElementMixin,
} from "%/dynamic-component-editor/standard-components/subscription-payment-card/subscription-payment-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "SubscriptionPaymentStatus",
  elementPanelSettings: {
    displayName: "Payment Status",
    displayIcon: "text-alt",
    elementGroup: "subscriptionPaymentElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [SubscriptionPaymentCardElementMixin],
  computed: {
    value() {
      const status = this.entity.status;
      if (!status) {
        return "";
      }
      return PAYMENT_STATUS_LABELS[status] ?? PAYMENT_STATUS_UNKNOWN_LABEL;
    },
  },
};
</script>
